module.exports = __webpack_public_path__ + "media/entities/1607-ab72ee08.png";